import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const downloadPDF = async (elementId, headerData = {}) => {
  const { title = "Quiz Result", name = "User" } = headerData;

  const input = document.getElementById(elementId);

  const canvas = await html2canvas(input, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
  });

  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF("p", "mm", "a4");

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const marginLeft = 10;
  const marginRight = 10;
  const marginTop = 10;
  const marginBottom = 10;

  const headerHeight = 18;
  const footerHeight = 10;

  const usableWidth = pageWidth - marginLeft - marginRight;
  const usableHeight =
    pageHeight - marginTop - marginBottom - headerHeight - footerHeight;

  const imgWidth = usableWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  const totalPages = Math.ceil(imgHeight / usableHeight);
  const today = new Date().toLocaleString();

  const addHeader = () => {
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(14);
    pdf.text(title, marginLeft, marginTop + 7);

    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(10);
    pdf.text(`Name: ${name}`, marginLeft, marginTop + 13);
    pdf.text(`Date: ${today}`, pageWidth - marginRight - 60, marginTop + 13);

    pdf.setDrawColor(180);
    pdf.line(
      marginLeft,
      marginTop + headerHeight,
      pageWidth - marginRight,
      marginTop + headerHeight
    );
  };

  const addFooter = (pageNum) => {
    pdf.setDrawColor(180);
    pdf.line(
      marginLeft,
      pageHeight - marginBottom - footerHeight,
      pageWidth - marginRight,
      pageHeight - marginBottom - footerHeight
    );

    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(10);
    pdf.text(
      `Page ${pageNum} of ${totalPages}`,
      pageWidth / 2,
      pageHeight - marginBottom - 3,
      { align: "center" }
    );
  };

  for (let page = 1; page <= totalPages; page++) {
    if (page > 1) pdf.addPage();

    addHeader();

    const yStart = marginTop + headerHeight + 2;
    const positionY = yStart - usableHeight * (page - 1);

    pdf.addImage(imgData, "PNG", marginLeft, positionY, imgWidth, imgHeight);
    addFooter(page);
  }

  pdf.save("quiz-result.pdf");
};
